// Mock data for For Mentors Page

export const mentorMetrics = [
  {
    number: "10K+",
    label: "Students Impacted"
  },
  {
    number: "250+",
    label: "Active Mentors"
  },
  {
    number: "100+",
    label: "Companies Represented"
  }
];

export const mentorRoles = [
  {
    id: 1,
    title: "Deliver Workshops & Masterclasses",
    description: "Share your expertise through industry case sessions and skill-building workshops"
  },
  {
    id: 2,
    title: "Guide Real Student Projects",
    description: "Mentor students on practical projects that solve real business challenges"
  },
  {
    id: 3,
    title: "Participate in Viva Panels",
    description: "Evaluate student work and provide industry-standard skill assessments"
  },
  {
    id: 4,
    title: "Influence Curriculum Relevance",
    description: "Help shape academic programs to match current industry requirements"
  }
];

export const leadingOrganizations = [
  "TCS", "Infosys", "Wipro", "HCL", "Cognizant", "Accenture", 
  "Amazon", "Google", "Deloitte", "KPMG", "ICICI Bank", "HDFC Bank", 
  "Apollo", "Zoho", "Flipkart"
];

export const industryCategories = [
  {
    id: 1,
    category: "Technology & IT",
    roles: ["Full Stack Developers", "Cloud Architects", "DevOps Engineers"],
    companies: "TCS, Infosys, Zoho, AWS, Google"
  },
  {
    id: 2,
    category: "AI & Data Science",
    roles: ["Data Scientists", "ML Engineers", "Data Analysts"],
    companies: "Amazon, Google, Tiger Analytics"
  },
  {
    id: 3,
    category: "Marketing & Growth",
    roles: ["Digital Marketers", "Brand Managers", "Growth Specialists"],
    companies: "HUL, ITC, Swiggy, Flipkart"
  },
  {
    id: 4,
    category: "Sales & Revenue",
    roles: ["Sales Leaders", "Area Managers", "B2B Experts"],
    companies: "IndiaMART, Zoho, Freshworks"
  },
  {
    id: 5,
    category: "Finance & Accounting",
    roles: ["Chartered Accountants", "Financial Analysts", "CFOs"],
    companies: "Deloitte, KPMG, PwC, EY"
  },
  {
    id: 6,
    category: "HR & Talent",
    roles: ["HR Business Partners", "Talent Acquisition Leads"],
    companies: "TCS, Infosys, Accenture, HCL"
  },
  {
    id: 7,
    category: "Operations & Supply Chain",
    roles: ["Supply Chain Managers", "Logistics Heads"],
    companies: "Amazon, Blue Dart, DHL"
  },
  {
    id: 8,
    category: "Healthcare & Life Sciences",
    roles: ["Hospital Administrators", "Healthcare Ops Managers"],
    companies: "Apollo, Fortis, Global Hospitals"
  },
  {
    id: 9,
    category: "Entrepreneurship",
    roles: ["Startup Founders", "MSME Business Owners"],
    companies: "Zoho Alumni, Freshworks Alumni"
  }
];

// Mock data for About Founder Page

export const founderInfo = {
  name: "N. Prabhakar Naidu",
  title: "Founder - EduSocial",
  designation: "IICA-Certified Independent Director",
  experience: "35+ Years Experience",
  bio: "An IICA-Certified Independent Director and Education Sector Advisor with over 35 years of leadership experience across education, human capital development, and institutional transformation.",
  photo: "https://customer-assets.emergentagent.com/job_edu-social-design/artifacts/95rekjz9_Prabhakar%20Naidu%20photo.png"
};

export const strategicExpertise = [
  {
    id: 1,
    title: "Institutional Scaling",
    description: "Transformation and expansion strategies"
  },
  {
    id: 2,
    title: "Human Capital Strategy",
    description: "Leadership development programs"
  },
  {
    id: 3,
    title: "EdTech Integration",
    description: "Digital transformation initiatives"
  },
  {
    id: 4,
    title: "Academia-Industry Alignment",
    description: "Bridging education and career"
  }
];

export const leadershipExperience = [
  {
    id: 1,
    company: "Vinsol HRD Pvt. Ltd.",
    duration: "10 Years",
    role: "Senior Leadership",
    achievements: [
      "Led large-scale education initiatives",
      "Capability development programs",
      "Institutional expansion strategies"
    ]
  },
  {
    id: 2,
    company: "Aspire Human Capital Management",
    duration: "3 Years",
    role: "Vice President",
    achievements: [
      "Human capital strategy implementation",
      "Leadership development programs",
      "Organizational excellence initiatives"
    ]
  },
  {
    id: 3,
    company: "Everonn Education Ltd.",
    duration: "3 Years",
    role: "Vice President",
    achievements: [
      "EdTech integration and scaling",
      "Talent ecosystem development",
      "Academic program evolution"
    ]
  }
];

export const experienceSpans = [
  "Institutional scaling and transformation",
  "Education technology integration",
  "Organizational restructuring and governance frameworks",
  "Human capital strategy and leadership development",
  "Academic-industry alignment models",
  "Talent ecosystem development across evolving learning environments"
];

export const governanceAreas = [
  "Strategic Advisory & Long-term Planning",
  "Regulatory Oversight & Compliance",
  "Risk Management & Governance Structures",
  "Stakeholder Engagement"
];

export const visionStatement = "At EduSocial, the vision is to build a structured industry-integrated learning ecosystem that bridges academia and real-world professional expertise.";

export const visionPillars = [
  "Education must evolve with technology",
  "Institutions must remain adaptive",
  "Leadership must be forward-thinking yet grounded in strong governance"
];

export const philosophy = [
  "Build thoughtfully.",
  "Evolve continuously.",
  "Empower education to create lasting impact."
];
